import { Client } from '../../types';

const clients: Record<string, Client> = {
  payment: {
    redirectUrls: [
      'https://payment.qa.favrit.com',
      'https://payment.favrit.com',
    ],
  },
  'bar-waiter': {
    redirectUrls: [
      'https://bar-waiter.qa.favrit.com',
      'https://bar-waiter.favrit.com',
      'https://epos.qa.favrit.com',
      'https://epos.favrit.com',
      'http://localhost:1234',
    ],
  },
  'menu-client': {
    redirectUrls: ['https://product-explorer.qa.favrit.com'],
  },
  'supplier-platform': {
    redirectUrls: [
      'https://supplier.qa.favrit.com',
      'https://supplier.favrit.com',
    ],
  },
  'masterdata-client': {
    redirectUrls: [
      'https://masterdata.qa.favrit.com',
      'https://masterdata.favrit.com',
    ],
  },
  'menu-builder': {
    redirectUrls: [
      'https://menu.dev.favrit.com',
      'https://menu.qa.favrit.com',
      'https://menu.favrit.com',
    ],
  },
  stocktake: {
    redirectUrls: [
      'https://stocktake.qa.favrit.com',
      'https://stocktake.favrit.com',
    ],
  },
  'customer-onboarding': {
    redirectUrls: [
      'https://onboarding.qa.favrit.com',
      'https://onboarding.favrit.com',
    ],
  },
  admin: {
    redirectUrls: [
      'https://admin.qa.favrit.com/#/auth/callback',
      'https://admin.favrit.com/#/auth/callback',
      'http://localhost:4200/#/auth/callback',
    ],
  },
};

export default clients;
